import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ComponentsModule } from '../../components/components.module';
import { MessageModalPage } from './message-modal';

@NgModule({
	declarations: [
		MessageModalPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(MessageModalPage),
	],
})
export class MessageModalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/message-modal/message-modal.module.ts